<template>
  <v-container
    fluid
    class="section__item background-position"
    :class="{ backgroundLeft: model.focusLeft }"
    :style="{ backgroundImage: 'url(' + model.img + ')' }"
  >
    <v-row
      v-if="
        !model.slider &&
          !model.TextColumn &&
          !model.TextColumns &&
          !model.WhatWeDo &&
          !model.Testimonials &&
          !model.Profiles
      "
    >
      <v-col class="section__column">
        <h4 class="section__name" :class="{ txtWhite: model.white }">
          {{ model.Name }}
        </h4>
        <div
          class="section__content"
          :class="{
            disclaimer: model.Disclaimer,
            small__banner: model.BannerSmall,
          }"
        >
          <div
            class="section__content__wrapper"
            :class="{
              small__banner: model.BannerSmall,
              focusLeft: model.focusLeft,
            }"
          >
            <h2 class="section__title" :class="{ txtWhite: model.white }">
              {{ model.Title }}
            </h2>
            <h3 class="section__subtitle">{{ model.Subtitle }}</h3>
            <p class="section__description" :class="{ txtWhite: model.white }">
              {{ model.Description }}
            </p>
            <div
              class="section__description"
              :class="{ txtWhite: model.white }"
              v-html="model.HTMLDescription"
            ></div>
            <a
              v-if="model.ctaButton"
              class="section__btn"
              :class="{ btnWhite: model.white }"
              :href="model.ctaLink"
              >{{ model.ctaButton }}</a
            >
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="model.Profiles">
      <v-col class="section__column">
        <h4 class="section__name">{{ model.Name }}</h4>
        <div class="section__content section__content--profiles">
          <div class="" v-for="(bio, i) in model.Bios" :key="i">
            <v-row v-if="bio.left">
              <v-col cols="12" md="6" class="bio__column">
                <img :class="{ bio__image: bio.last }" :src="bio.img" />
              </v-col>
              <v-col cols="12" md="6" align-self="center" class="bio__column">
                <h2 class="bio__title">{{ bio.Title }}</h2>
                <h3 class="bio__subtitle">
                  <strong>{{ bio.Subtitle }}</strong>
                </h3>
                <p>
                  <a class="bio__linkedin" :href="bio.Linkedin">{{
                    bio.Linkedin
                  }}</a>
                </p>
                <p>
                  <a class="bio__email" :href="'mailto:' + bio.Email">{{
                    bio.Email
                  }}</a>
                </p>
                <p>
                  <a class="bio__tel" :href="'tel:' + bio.Tel"
                    >Tel: {{ bio.Tel }}</a
                  >
                </p>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" md="6" align-self="center" class="bio__column">
                <h2 class="bio__title">{{ bio.Title }}</h2>
                <h3 class="bio__subtitle">
                  <strong>{{ bio.Subtitle }}</strong>
                </h3>
                <p>
                  <a class="bio__linkedin" :href="bio.Linkedin">{{
                    bio.Linkedin
                  }}</a>
                </p>
                <p>
                  <a class="bio__email" :href="'mailto:' + bio.Email">{{
                    bio.Email
                  }}</a>
                </p>
                <p>
                  <a class="bio__tel" :href="'tel:' + bio.Tel"
                    >Tel: {{ bio.Tel }}</a
                  >
                </p>
              </v-col>
              <v-col cols="12" md="6" class="bio__column">
                <img
                  :class="{ bio__last: bio.last }"
                  class="bio__image"
                  :src="bio.img"
                />
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="model.TextColumn" class="section__column">
      <v-col cols="12" md="6" v-if="model.TextColumn2">
        <div v-html="model.TextColumn1" class="section__column__one"></div>
      </v-col>
      <v-col cols="12" v-else>
        <div v-html="model.TextColumn1" class="section__column__one"></div>
      </v-col>
      <v-col cols="12" md="6" v-if="model.TextColumn2">
        <img class="slide__decoration" :src="model.Decoration" />
        <div v-html="model.TextColumn2" class="section__column__two"></div>
      </v-col>
    </v-row>
    <v-row v-if="model.TextColumns">
      <v-col cols="12">
        <v-row class="section__column">
          <v-col cols="12" md="6">
            <div v-html="model.TextColumns1"></div>
          </v-col>
          <v-col cols="12" md="6">
            <div v-html="model.TextColumns2"></div>
          </v-col>
        </v-row>
        <v-row class="section__column">
          <v-col cols="12">
            <div v-html="model.TextColumns3"></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="model.Testimonials" class="section__column">
      <v-row>
        <v-col cols="12">
          <h3 class="text-column__title">{{ model.Title }}</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="6"
          v-for="(testi, i) in model.Testimonial"
          :key="i"
        >
          <img class="slide__decoration" :src="model.Decoration" />
          <blockquote
            class="testimonial testimonial__content"
            v-html="testi.Content"
          ></blockquote>
          <blockquote
            class="testimonial testimonial__author"
            v-html="testi.Author"
          ></blockquote>
        </v-col>
      </v-row>
    </v-row>
    <v-row v-if="model.WhatWeDo" class="section__column">
      <v-row>
        <v-col cols="12">
          <h3 class="text-column__title">{{ model.Title }}</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h4 class="section__name">{{ model.Name }}</h4>
        </v-col>
        <v-col cols="12" md="6" v-for="(block, i) in model.What" :key="i">
          <a class="block__link" :href="block.link">
            <div class="block__wrapper">
              <img class="block__image" :src="block.img" />
              <h2 class="block__title" v-html="block.title"></h2>
              <h3 class="block__subtitle" v-html="block.subtitle"></h3>
            </div>
          </a>
        </v-col>
      </v-row>
    </v-row>
    <v-row v-if="model.slider">
      <v-col class="section__column">
        <h4 class="section__name" :class="{ txtWhite: model.white }">
          {{ model.Name }}
        </h4>
        <div class="section__content">
          <div class="section__content__wrapper--slide">
            <h2
              class="section__title section__title--slider"
              :class="{ txtWhite: model.white }"
            >
              {{ model.Title }}
            </h2>
            <h3 class="section__subtitle">{{ model.Subtitle }}</h3>
            <img class="slide__decoration" :src="model.Decoration" />
            <v-carousel
              cycle
              interval="6000"
              hide-delimiter-background
              :show-arrows="false"
            >
              <v-carousel-item
                class="slide__wrapper"
                v-for="(text, i) in model.SlideSection"
                :key="i"
              >
                <v-sheet class="slide__item">
                  <v-row align="center" justify="center">
                    <v-col class="slide__column">
                      <div class="display-1 text-center slide__content">
                        <div class="slide__content__wrapper">
                          <p
                            class="slide__description"
                            :class="{ txtWhite: model.white }"
                            v-html="text"
                          ></p>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      default: {},
    },
  },
};
</script>

<style lang="scss" scoped></style>
